import React, { useContext } from 'react';
import { SpringRef } from '@react-spring/web';
import type { TTextBoxContentItem } from '@src/types/wysiwyg_editor';
import type { SprungRect, TRect } from '../../../types/misc';
import type {
  TOverlayLocations,
  TSprungOverlayLocations
} from '../../../utils/wysiwyg_editor/contentItemHandleLocations';
import { WysiwygEditorStateContext } from '@src/contexts/wysiwyg/editor';
import Preview from './text_box/Preview';
import Builder from './text_box/Builder';

export interface Props {
  data: TTextBoxContentItem;
  frameDomSpringValues: TSprungOverlayLocations;
  frameDomSpringApi: SpringRef<TOverlayLocations>;
  frameViewboxSpringValues: SprungRect;
  frameViewboxSpringApi: SpringRef<TRect>;
}

function TextBox(props: Props): React.ReactElement {
  const { productionRender } = useContext(WysiwygEditorStateContext);

  if (productionRender) {
    return <Preview {...props} />;
  } else {
    return <Builder {...props} />;
  }
}

export default TextBox;
